// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".EntityNameLabel__entityDescription___2-AL4{font-weight:400;color:#999;font-size:14px}\n", ""]);
// Exports
exports.locals = {
	"entityDescription": "EntityNameLabel__entityDescription___2-AL4"
};
module.exports = exports;
